// import song from "../assets/songs_thumb/oo_antava_thumb.jpeg";

export const songs = [
  {
    _id: 10000001,
    title: "Saami Saami",
    thumbnail: require("../assets/songs_thumb/saamisaamithumb.jpeg"),
    singer: "Devi Sri Prasad",
    singerThumb: require("../assets/artist_assets/DeviSriPrasad.jpeg"),
    movie: "Pushpa The Rise Part-01",
    language: "hindi",
    type: "song",
    year: "2021",
    bgGradient: "#ff0000,#11111130",
    song: require("./audio_songs/Pushpa_ Saami Saami - Lyrical (Hindi) _ Allu Arjun, Rashmika Mandanna _ Sunidhi C _ DSP _ Sukumar.mp3"),
  },
  {
    _id: 10000002,
    title: "Oo Bolega Ya Oo Oo Bolega",
    thumbnail: require("../assets/songs_thumb/oo_antava_thumb.jpeg"),
    movie: "Pushpa The Rise Part-01",
    singer: "Kanika Kapoor",
    singerThumb: require("../assets/artist_assets/KanikaKapoor.jpeg"),
    language: "hindi",
    type: "song",
    year: "2021",
    bgGradient: "#00ff00,#11111130",
    song: require("./audio_songs/OoBolegayaOoOoBolega.mp3"),
  },
  {
    _id: 10000003,
    title: "Raataan Lambiyan",
    thumbnail: require("../assets/songs_thumb/RaataanLambiyan.jpeg"),
    singer: "Jubin Nautiyal",
    singerThumb: require("../assets/artist_assets/JubinNautiyal.jpeg"),
    movie: "Shershaah",
    language: "hindi",
    type: "song",
    year: "2021",
    bgGradient: "#ffaa00,#11111130",
    song: require("./audio_songs/RaataanLambiyan.mp3"),
  },
  {
    _id: 10000004,
    title: "Faded",
    thumbnail: require("../assets/songs_thumb/faded.jpg"),
    singer: "alan walker",
    singerThumb: require("../assets/artist_assets/alanwalker.jpeg"),
    movie: "",
    language: "english",
    type: "song",
    year: "2018",
    bgGradient: "#006600,#11111130",
    song: require("./audio_songs/AlanWalkerFaded.mp3"),
  },
  {
    _id: 10000005,
    title: "Adhir Man Jhale",
    thumbnail: require("../assets/songs_thumb/AdhirMan.jpeg"),
    singer: "Shreya Ghoshal",
    singerThumb: require("../assets/artist_assets/ShreyaGhoshal.jpeg"),
    movie: "",
    language: "marathi",
    type: "song",
    year: "2016",
    bgGradient: "#ff00aa,#11111130",
    song: require("./audio_songs/AdhirMan.mp3"),
  },
  {
    _id: 10000006,
    title: "Alone",
    thumbnail: require("../assets/songs_thumb/alanwalkeralone.jpeg"),
    singer: "alan walker",
    singerThumb: require("../assets/artist_assets/alanwalker.jpeg"),
    movie: "",
    language: "english",
    type: "song",
    year: "2018",
    bgGradient: "#ffbbaa,#11111130",
    song: require("./audio_songs/AlanWalkerAlone.mp3"),
  },
  {
    _id: 10000007,
    title: "Swarg Ha Nava",
    thumbnail: require("../assets/songs_thumb/SwargHaNava.jpeg"),
    singer: "Ajay-Atul",
    singerThumb: require("../assets/playlist_thumb/BestOfAjayAtul.jpeg"),
    movie: "",
    language: "marathi",
    type: "song",
    year: "2018",
    bgGradient: "#00ff00,#11111130",
    song: require("./audio_songs/SwargHaNava.mp3"),
  },
  {
    _id: 10000008,
    title: "Galavar Khali",
    thumbnail: require("../assets/songs_thumb/GalavarKhali.jpeg"),
    singer: "Ajay-Atul",
    singerThumb: require("../assets/playlist_thumb/BestOfAjayAtul.jpeg"),
    movie: "",
    language: "marathi",
    type: "song",
    year: "2018",
    bgGradient: "#aaff,#11111130",
    song: require("./audio_songs/GalavarKhali.mp3"),
  },
  {
    _id: 10000009,
    title: "Kombadi Palali",
    thumbnail: require("../assets/songs_thumb/KombadiPalali.jpeg"),
    singer: "Ajay-Atul",
    singerThumb: require("../assets/playlist_thumb/BestOfAjayAtul.jpeg"),
    movie: "",
    language: "marathi",
    type: "song",
    year: "2018",
    bgGradient: "#ffbb,#11111130",
    song: require("./audio_songs/KombadiPalali.mp3"),
  },
  {
    _id: 10000010,
    title: "Ye Go Ye Ye Maina",
    thumbnail: require("../assets/songs_thumb/YeGoYeYeMaina.jpeg"),
    singer: "Ajay-Atul",
    singerThumb: require("../assets/playlist_thumb/BestOfAjayAtul.jpeg"),
    movie: "",
    language: "marathi",
    type: "song",
    year: "2018",
    bgGradient: "#ccacca,#11111130",
    song: require("./audio_songs/YeGoYeYeMaina.mp3"),
  },
  {
    _id: 10000011,
    title: "Mauli Mauli",
    thumbnail: require("../assets/songs_thumb/MauliMauli.jpeg"),
    singer: "Ajay-Atul",
    singerThumb: require("../assets/playlist_thumb/BestOfAjayAtul.jpeg"),
    movie: "",
    language: "marathi",
    type: "song",
    year: "2018",
    bgGradient: "#ffffaa,#11111130",
    song: require("./audio_songs/MauliMauli.mp3"),
  },

  // podcasts
  {
    _id: 20000001,
    title: "Maha Bharart with Dhruv",
    thumbnail: require("../assets/songs_thumb/mahabharat.jpeg"),
    movie: "",
    singer: "Dhruv Rathee",
    singerThumb: require("../assets/artist_assets/DhruvRathee.jpeg"),
    language: "hindi",
    type: "podcast",
    year: "2021",
    bgGradient: "#0000dd,#11111130",
    song: require("./audio_songs/Pushpa_ Saami Saami - Lyrical (Hindi) _ Allu Arjun, Rashmika Mandanna _ Sunidhi C _ DSP _ Sukumar.mp3"),
  },

  {
    _id: 20000002,
    title: "The Stories Of Mahabharat",
    thumbnail: require("../assets/songs_thumb/mahabharatbysudipta.jpeg"),
    movie: "",
    singer: "Sudipta Bhawmik",
    singerThumb: require("../assets/artist_assets/SudiptaBhawmik.jpeg"),
    language: "hindi",
    type: "podcast",
    year: "2020",
    bgGradient: "#aa00dd,#11111130",
    song: require("./audio_songs/Pushpa_ Saami Saami - Lyrical (Hindi) _ Allu Arjun, Rashmika Mandanna _ Sunidhi C _ DSP _ Sukumar.mp3"),
  },

  {
    _id: 20000003,
    title: "The Ranveer Show",
    thumbnail: require("../assets/songs_thumb/ranveerpodcast.jpeg"),
    movie: "",
    singer: "BeerBiceps aka Ranveer Allahbadia",
    singerThumb: require("../assets/artist_assets/RanveerAllahbadia.jpeg"),
    language: "hindi",
    type: "podcast",
    year: "2021",
    bgGradient: "#00aadd,#11111130",
    song: require("./audio_songs/Pushpa_ Saami Saami - Lyrical (Hindi) _ Allu Arjun, Rashmika Mandanna _ Sunidhi C _ DSP _ Sukumar.mp3"),
  },
];

export const playList = [
  {
    _id: 30000001,
    playListTitle: "Best Of Pushpa",
    tag: "Pushpa The Rise Part-01",
    bgGradient: "#00ffdd,#11111130",
    playListThumbnail: require("../assets/playlist_thumb/BestOfPushpa.jpeg"),
    playListSongs: [
      {
        _id: 10000001,
        title: "Saami Saami",
        thumbnail: require("../assets/songs_thumb/saamisaamithumb.jpeg"),
        singer: "Devi Sri Prasad",
        singerThumb: require("../assets/artist_assets/DeviSriPrasad.jpeg"),
        movie: "Pushpa The Rise Part-01",
        language: "hindi",
        type: "song",
        year: "2021",
        bgGradient: "#ff0000,#11111130",
        song: require("./audio_songs/Pushpa_ Saami Saami - Lyrical (Hindi) _ Allu Arjun, Rashmika Mandanna _ Sunidhi C _ DSP _ Sukumar.mp3"),
      },
      {
        _id: 10000002,
        title: "Oo Bolega Ya Oo Oo Bolega",
        thumbnail: require("../assets/songs_thumb/oo_antava_thumb.jpeg"),
        movie: "Pushpa The Rise Part-01",
        singer: "Kanika Kapoor",
        singerThumb: require("../assets/artist_assets/KanikaKapoor.jpeg"),
        language: "hindi",
        type: "song",
        year: "2021",
        bgGradient: "#00ff00,#11111130",
        song: require("./audio_songs/OoBolegayaOoOoBolega.mp3"),
      },
    ],
  },
  {
    _id: 30000002,
    playListTitle: "Best Of 2021",
    tag: "year",
    bgGradient: "#00eedd,#11111130",
    playListThumbnail: require("../assets/playlist_thumb/BestOf2021.jpeg"),
    playListSongs: [
      {
        _id: 10000001,
        title: "Saami Saami",
        thumbnail: require("../assets/songs_thumb/saamisaamithumb.jpeg"),
        singer: "Devi Sri Prasad",
        singerThumb: require("../assets/artist_assets/DeviSriPrasad.jpeg"),
        movie: "Pushpa The Rise Part-01",
        language: "hindi",
        type: "song",
        year: "2021",
        bgGradient: "#ff0000,#11111130",
        song: require("./audio_songs/Pushpa_ Saami Saami - Lyrical (Hindi) _ Allu Arjun, Rashmika Mandanna _ Sunidhi C _ DSP _ Sukumar.mp3"),
      },
      {
        _id: 10000002,
        title: "Oo Bolega Ya Oo Oo Bolega",
        thumbnail: require("../assets/songs_thumb/oo_antava_thumb.jpeg"),
        movie: "Pushpa The Rise Part-01",
        singer: "Kanika Kapoor",
        singerThumb: require("../assets/artist_assets/KanikaKapoor.jpeg"),
        language: "hindi",
        type: "song",
        year: "2021",
        bgGradient: "#00ff00,#11111130",
        song: require("./audio_songs/OoBolegayaOoOoBolega.mp3"),
      },
      {
        _id: 10000003,
        title: "Raataan Lambiyan",
        thumbnail: require("../assets/songs_thumb/RaataanLambiyan.jpeg"),
        singer: "Jubin Nautiyal",
        singerThumb: require("../assets/artist_assets/JubinNautiyal.jpeg"),
        movie: "Shershaah",
        language: "hindi",
        type: "song",
        year: "2021",
        bgGradient: "#ffaa00,#11111130",
        song: require("./audio_songs/RaataanLambiyan.mp3"),
      },
      {
        _id: 20000003,
        title: "The Ranveer Show",
        thumbnail: require("../assets/songs_thumb/ranveerpodcast.jpeg"),
        movie: "",
        singer: "BeerBiceps aka Ranveer Allahbadia",
        singerThumb: require("../assets/artist_assets/RanveerAllahbadia.jpeg"),
        language: "hindi",
        type: "podcast",
        year: "2021",
        bgGradient: "#00aadd,#11111130",
        song: require("./audio_songs/Pushpa_ Saami Saami - Lyrical (Hindi) _ Allu Arjun, Rashmika Mandanna _ Sunidhi C _ DSP _ Sukumar.mp3"),
      },
    ],
  },
  {
    _id: 30000003,
    playListTitle: "Best Of 2018",
    tag: "year",
    bgGradient: "#00ccdd,#11111130",
    playListThumbnail: require("../assets/playlist_thumb/BestOf2018.jpeg"),
    playListSongs: [
      {
        _id: 10000006,
        title: "Alone",
        thumbnail: require("../assets/songs_thumb/alanwalkeralone.jpeg"),
        singer: "alan walker",
        singerThumb: require("../assets/artist_assets/alanwalker.jpeg"),
        movie: "",
        language: "english",
        type: "song",
        year: "2018",
        bgGradient: "#ffaaaa,#11111130",
        song: require("./audio_songs/AlanWalkerAlone.mp3"),
      },
    ],
  },
  {
    _id: 30000004,
    playListTitle: "Best Of Devi Sri Prasad",
    tag: "singer",
    bgGradient: "#00cc,#11111130",
    playListThumbnail: require("../assets/artist_assets/DeviSriPrasad.jpeg"),
    playListSongs: [
      {
        _id: 10000001,
        title: "Saami Saami",
        thumbnail: require("../assets/songs_thumb/saamisaamithumb.jpeg"),
        singer: "Devi Sri Prasad",
        singerThumb: require("../assets/artist_assets/DeviSriPrasad.jpeg"),
        movie: "Pushpa The Rise Part-01",
        language: "hindi",
        type: "song",
        year: "2021",
        bgGradient: "#ff0000,#11111130",
        song: require("./audio_songs/Pushpa_ Saami Saami - Lyrical (Hindi) _ Allu Arjun, Rashmika Mandanna _ Sunidhi C _ DSP _ Sukumar.mp3"),
      },
    ],
  },
  {
    _id: 30000005,
    playListTitle: "Best Of Ajay Atul",
    tag: "singer",
    bgGradient: "#FFA500,#11111130",
    playListThumbnail: require("../assets/playlist_thumb/BestOfAjayAtul.jpeg"),
    playListSongs: [
      {
        _id: 10000007,
        title: "Swarg Ha Nava",
        thumbnail: require("../assets/songs_thumb/SwargHaNava.jpeg"),
        singer: "Ajay-Atul",
        singerThumb: require("../assets/playlist_thumb/BestOfAjayAtul.jpeg"),
        movie: "",
        language: "marathi",
        type: "song",
        year: "2018",
        bgGradient: "#00ff00,#11111130",
        song: require("./audio_songs/SwargHaNava.mp3"),
      },
      {
        _id: 10000008,
        title: "Galavar Khali",
        thumbnail: require("../assets/songs_thumb/GalavarKhali.jpeg"),
        singer: "Ajay-Atul",
        singerThumb: require("../assets/playlist_thumb/BestOfAjayAtul.jpeg"),
        movie: "",
        language: "marathi",
        type: "song",
        year: "2018",
        bgGradient: "#aaff,#11111130",
        song: require("./audio_songs/GalavarKhali.mp3"),
      },
      {
        _id: 10000009,
        title: "Kombadi Palali",
        thumbnail: require("../assets/songs_thumb/KombadiPalali.jpeg"),
        singer: "Ajay-Atul",
        singerThumb: require("../assets/playlist_thumb/BestOfAjayAtul.jpeg"),
        movie: "",
        language: "marathi",
        type: "song",
        year: "2018",
        bgGradient: "#ffbb,#11111130",
        song: require("./audio_songs/KombadiPalali.mp3"),
      },
      {
        _id: 10000010,
        title: "Ye Go Ye Ye Maina",
        thumbnail: require("../assets/songs_thumb/YeGoYeYeMaina.jpeg"),
        singer: "Ajay-Atul",
        singerThumb: require("../assets/playlist_thumb/BestOfAjayAtul.jpeg"),
        movie: "",
        language: "marathi",
        type: "song",
        year: "2018",
        bgGradient: "#ccacca,#11111130",
        song: require("./audio_songs/YeGoYeYeMaina.mp3"),
      },
      {
        _id: 10000011,
        title: "Mauli Mauli",
        thumbnail: require("../assets/songs_thumb/MauliMauli.jpeg"),
        singer: "Ajay-Atul",
        singerThumb: require("../assets/playlist_thumb/BestOfAjayAtul.jpeg"),
        movie: "",
        language: "marathi",
        type: "song",
        year: "2018",
        bgGradient: "#ffffaa,#11111130",
        song: require("./audio_songs/MauliMauli.mp3"),
      },
    ],
  },
];
